<template>
    <tr>
        <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex flex-col justify-center">
                <div class="text-sm font-medium text-gray-400">
                    <span> {{ user.id }}</span>
                </div>
                <div class="flex text-xs pt-1 opacity-70">
                    <LastLoginBadge :user="user"></LastLoginBadge>
                </div>
            </div>
        </td>
        <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
                <div class="text-sm font-medium text-gray-900">
                    <div class="text-lg text-primary-500">
                        <Link :href="user.show_url" target="_blank"
                              class="text-primary-600 hover:text-primary-900">
                            {{ user.name }}
                        </Link>
                    </div>
                </div>
            </div>
        </td>
        <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
                <div class="text-sm font-medium text-gray-400">
                    {{ user.email }}
                </div>
            </div>
        </td>
        <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <div class="flex items-center justify-end space-x-3" v-if="canDelete">
                <a
                    href="#"
                    @click.prevent="detach()"
                    class="pl-2 sm:pl-4 py-1 text-sm leading-5 font-medium text-danger-700 hover:text-danger-400">
                    <template v-if="!isLoading">
                        <MinusCircleIcon class="w-5 h-5"></MinusCircleIcon>
                    </template>
                    <template v-else>
                        <MinusCircleIcon class="animate-spin h-5 w-5"></MinusCircleIcon>
                    </template>
                </a>
            </div>
        </td>
    </tr>
</template>

<script setup>
import {MinusCircleIcon, RefreshIcon} from '@heroicons/vue/solid'
import LastLoginBadge from "./UserProfile/LastLoginBadge.vue";
</script>

<script>

import {Link} from "@inertiajs/vue3";

export default {
    name: "UserManagerUserLine",
    components: {
        Link,
    },
    props: {
        user: Object,
        canDelete: Boolean,
        detachEndpoint: String,
    },
    computed: {},
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        detach() {
            if (this.canDelete && !this.isLoading) {
                this.$inertia.delete(this.detachEndpoint, {
                    preserveScroll: true,
                    preserveState: true,
                    onStart: () => (this.isLoading = true),
                    onFinish: () => (this.isLoading = false),
                })
            }
        }
    },
}
</script>

<style scoped>

</style>
